<div class="dialog-content-wrapper">
  <mat-toolbar mat-dialog-title class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">Verify your account</span>
      <button (click)="closeMicrodepositVerifyDialog()" aria-label="Close dialog">
        <mat-icon class="closebtn">close</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <mat-progress-bar *ngIf="loading" mode="query" class="my-color" mode="query" value="value"
    [bufferValue]="bufferValue"></mat-progress-bar>
  <div class="">
    <div fxFlex class="mat-elevation-z2 ach-body">
      <div>
        <br>
        <span class="title dialog-title">Please enter the two small amounts credited to your account</span>
        <br />
        <form class="example-form" fxLayout="column" [formGroup]="stripeAchVerifyMicroDepositForm" novalidate>
          <div fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="10px">
            <mat-form-field>
              <mat-label>First amount</mat-label>
              <input matInput type="number" name="first-number" placeholder="$" id="first-number"
                formControlName="first_number" min="1" max="5000" oninput="validity.valid||(value='');" />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Second amount</mat-label>
              <input matInput type="number" name="second-number" placeholder="$" id="second-number"
                formControlName="second_number" min="1" max="5000" oninput="validity.valid||(value='');" />
            </mat-form-field>
          </div>
          <div class="input-row">
            <span class="error" *ngFor="let err of stripeAchVerifyMicroDepositFormErrors">{{ err }}
              <br />
            </span>
          </div>
          <div class="input-row" fxLayoutAlign="end start">
            <button [class.loading]="loading" [disabled]="loading" mat-raised-button color="accent" type="submit"
              style="text-transform: uppercase" (click)="microdepositVerifySubmit()">
              <div class="spinner"></div>
              <span class="label">Verify</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/main/content/common/dialogs/ach-micro-deposit-verify/ach-micro-deposit-verify.component.html